import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { testimonialsService } from '../services/testimonials';
import type { CreateTestimonialInput, UpdateTestimonialInput } from '../types/entities';

// Get all testimonials
export function useTestimonials() {
  return useQuery({
    queryKey: ['testimonials'],
    queryFn: () => testimonialsService.getAll(),
  });
}

// Get testimonial by ID
export function useTestimonial(id: string) {
  return useQuery({
    queryKey: ['testimonials', id],
    queryFn: () => testimonialsService.getById(id),
    enabled: !!id,
  });
}

// Create testimonial
export function useCreateTestimonial() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateTestimonialInput) => testimonialsService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['testimonials'] });
    },
  });
}

// Update testimonial
export function useUpdateTestimonial() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTestimonialInput }) =>
      testimonialsService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['testimonials'] });
    },
  });
}

// Delete testimonial
export function useDeleteTestimonial() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => testimonialsService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['testimonials'] });
    },
  });
}
